/* eslint-disable import/prefer-default-export */
export function getUser() {
  const user = JSON.parse(localStorage.getItem('user_dzikra'));
  if (user) {
    return user;
  }
  return null;
}
